import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {MeshAfterEndCellView} from '@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/mesh/MeshAfterEndCellView';
import {MeshCellView} from '@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/mesh/MeshCellView';
import {computed} from 'mobx';
import {observer, inject} from 'mobx-react';
import * as React from 'react';
import {IWSPMeshContext} from '@mintdata-wsp/wsp/controllers/visualDesigner/spreadsheet/contexts/MeshContext';

const styles = require('@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/mesh/Mesh.less');

interface Props
{
    ctx?:IWSPMeshContext;
    rowIndex:number;
    isNested:boolean;
}

@inject('ctx')
@observer
export class MeshRowView extends React.Component<Props, any>
{
    @computed
    private get _height():number
    {
        const {ctx, rowIndex} = this.props;
        const meshState = controllers.ui.spreadsheets.mesh.getState(ctx);
        const {rowHeights, details: {resizingRowIndex, resizingRowHeight}, afterEndPartHeight} = meshState;

        if( typeof rowIndex !== 'number' )
            return afterEndPartHeight;

        return resizingRowIndex === rowIndex && resizingRowHeight != null
            ? resizingRowHeight
            : rowHeights[rowIndex];
    }

    @computed
    private get _style():React.CSSProperties
    {
        return {
            height: `${this._height}px`
        };
    }

    private _renderVisibleCols():Array<JSX.Element>
    {
        const {rowIndex, ctx, isNested} = this.props;
        const meshState = controllers.ui.spreadsheets.mesh.getState(ctx);
        const {visibleStartColIndex, visibleEndColIndex} = meshState;

        const cols:Array<JSX.Element> = [];

        for( let colIndex:number = visibleStartColIndex; colIndex <= visibleEndColIndex; colIndex++ )
            cols.push(<MeshCellView
                key={colIndex}
                colIndex={colIndex}
                rowIndex={rowIndex}
                isNested={isNested}
            />);

        return cols;
    }

    private _renderAfterEndCols():Array<JSX.Element>
    {
        const {ctx, isNested} = this.props;
        const meshState = controllers.ui.spreadsheets.mesh.getState(ctx);
        const {visibleStartColIndex, visibleEndColIndex} = meshState;

        const cols:Array<JSX.Element> = [];

        for( let colIndex:number = visibleStartColIndex; colIndex <= visibleEndColIndex; colIndex++ )
            cols.push(<MeshAfterEndCellView
                key={colIndex}
                colIndex={colIndex}
                rowIndex={null}
                isNested={isNested}
            />);

        return cols;
    }

    public render():JSX.Element
    {
        const {ctx} = this.props;
        const meshState = controllers.ui.spreadsheets.mesh.getState(ctx);
        const {size: {numRows}} = meshState;

        const {rowIndex, isNested} = this.props;

        if( typeof rowIndex !== 'number' && rowIndex >= numRows )
            return null;

        return <div style={this._style} className={styles.tableRow}>
            {typeof rowIndex === 'number' ? this._renderVisibleCols() : this._renderAfterEndCols()}

            <MeshAfterEndCellView
                colIndex={null}
                rowIndex={rowIndex}
                isNested={isNested}
            />
        </div>;
    }
}
